import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../../base/base-component.component';
import { SiteSettingModel, AuthenticationService } from '../../../services';

@Component({
  selector: 'left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css']
})
export class LeftMenuComponent extends BaseComponent implements OnInit {

  @Input()
  siteSettingModel: SiteSettingModel;
  isCage = false;

  userIsOwner: boolean;
  userIsDev: boolean;
  userIsEditor: boolean;
  userIsReadWrite: boolean;
  userIsReader: boolean;

  constructor(
    translateService: TranslateService,
    private authenticationService: AuthenticationService) {
    super(translateService);
    this.setTranslateContext('LeftMenuComponent');
  }

  ngOnInit() {
    this.userIsOwner = this.authenticationService.userHasRole("Owner");
    this.userIsDev = this.authenticationService.userHasRole("Developer");
    this.userIsEditor = this.authenticationService.userHasRole("Editor");
    this.userIsReadWrite = this.authenticationService.userHasRole("ReadWrite");
    this.userIsReader = this.authenticationService.userHasRole("Reader");
  }


  toggleIt() {
    const element: HTMLCollection = document.getElementsByTagName('body');
    if (element[0].classList.contains('open_menu')) {
      element[0].classList.remove('open_menu');
    } else {
      element[0].classList.add('open_menu');
    }
  }
}
